import type { BulkSettlementMeridiem, BulkSettlementTimeValue } from './types';

export const formatBulkSettlementTimeLabel = (time: BulkSettlementTimeValue): string =>
  `${time.hour.padStart(2, '0')}:${time.minute.padStart(2, '0')} ${time.meridiem}`;

export const getCurrentBulkSettlementTime = (): BulkSettlementTimeValue => {
  const now = new Date();
  const hours = now.getHours();
  const hour12 = hours % 12 || 12;
  return {
    hour: String(hour12),
    meridiem: hours >= 12 ? 'PM' : 'AM',
    minute: String(now.getMinutes()).padStart(2, '0'),
  };
};

export const timeValueTo24h = (time: BulkSettlementTimeValue): string => {
  const normalizedHour = Number(time.hour) % 12;
  const hour24 = time.meridiem === 'PM' ? normalizedHour + 12 : normalizedHour;
  return `${String(hour24).padStart(2, '0')}:${time.minute.padStart(2, '0')}`;
};

export const timeValueFrom24h = (value: string): BulkSettlementTimeValue => {
  const [h = '0', m = '00'] = value.split(':');
  const hour24 = Number(h);
  const meridiem: BulkSettlementMeridiem = hour24 >= 12 ? 'PM' : 'AM';
  const hour12 = hour24 % 12 || 12;
  return { hour: String(hour12), meridiem, minute: m };
};

export const formatBusinessDate = (date: Date): string => {
  const y = date.getFullYear();
  const mo = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${mo}-${d}`;
};
